import { recordFeeds } from "@/mocks/chigua";

export default function RecordsSection() {
  return (
    <section id="records" className="scroll-mt-28 bg-cream">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6">
        <div className="mb-9 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-ember/10 px-3 py-1 text-xs font-bold text-ember">
              <i className="ri-record-circle-line" />
              录屏流出 · 逐条标来源
            </span>
            <h2 className="mt-3 font-display-x text-3xl font-black md:text-4xl">
              录屏流出 · 原始视角看细节
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ink/60 md:text-base">
              设备直接录制、未裁剪的原始片段，统一标注来源与时长，适合需要完整过程佐证的场景。
            </p>
          </div>
        </div>

        <div className="space-y-4">
          {recordFeeds.map((r) => (
            <a
              key={r.title}
              href="#records"
              className="group grid grid-cols-1 gap-4 rounded-2xl bg-paper p-3 ring-1 ring-sand/60 transition hover:-translate-y-0.5 hover:ring-ember/30 sm:grid-cols-[220px_1fr_auto] sm:items-center"
            >
              <div className="relative h-36 w-full overflow-hidden rounded-xl bg-sand sm:h-24 sm:w-56">
                <img
                  src={r.cover}
                  alt={r.title}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <span className="absolute bottom-2 right-2 rounded bg-ink/75 px-1.5 py-0.5 font-mono text-[11px] text-cream">
                  {r.time}
                </span>
              </div>
              <div className="px-1 sm:px-2">
                <h3 className="text-base font-bold text-ink md:text-lg">{r.title}</h3>
                <p className="mt-1.5 text-xs text-ink/45">
                  <i className="ri-focus-3-line mr-1 text-ember" />
                  {r.source}
                </p>
              </div>
              <span className="flex items-center justify-start gap-2 whitespace-nowrap px-1 text-sm font-bold text-ember sm:justify-center sm:px-4">
                <i className="ri-eye-line" />
                查看流出
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}